module.exports = "https://assets.niwcorp.com/_next/static/images/img-oval-btm-right-3fb31559054f92e29361f7b45ade532a.svg";